import React, { useEffect, useRef, Fragment, useState } from "react";
import { styled, useTheme } from '@mui/material/styles';
import { MapContainer, TileLayer, GeoJSON, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { connect } from "react-redux";
import { layerGroup } from "leaflet";
import CircularProgress from "@mui/material/CircularProgress";

const PREFIX = 'Map';

const classes = {
  root: `${PREFIX}-root`,
  map: `${PREFIX}-map`,
  loadingContainer: `${PREFIX}-loadingContainer`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.map}`]: {
    borderRadius: "5px",
    width: "100%",
    height: "100%",
    minWidth: "100%",
    minHeight: "15rem",
    "& .leaflet-control-attribution": {
      display: "none",
    },
  },

  [`& .${classes.loadingContainer}`]: {
    width: "100%",
    height: "100%",
    display: "grid",
    justifyContent: "center",
    alignContent: "center",
    zIndex: 1000,
    position: "relative",
  }
}));

const styles = {
  analysisGeom: {
    color: "#999999",
    weight: 1,
    fillColor: "#005287",
    fillOpacity: 0.25,
  },
  geom: {
    color: "#4a83ec",
    weight: 2,
    fillColor: "#999999",
    fillOpacity: 0.25,
  },
};

// const Map = ({ details, geom, setGeom }) => {
const Map = ({ geom, analysisGeoms }) => {

  const theme = useTheme();
  const position = [39.8283, -98.5759];
  const map = useRef();
  const [mapLoading, setMapLoading] = useState(true);

  useEffect(() => {}, []);

  const MapEvents = () => {
    const map = useMapEvents({
      click: (e) => {
        console.log(e);
      },
      locationfound: (location) => {
        console.log("location found:", location);
      },
      layeradd: (layer) => {
        if (layer.layer.hasOwnProperty("_latlngs")) {
          map.flyToBounds(layer.layer._bounds);
        }
      },
    });
    return null;
  };

  const onLoad = () => {
    setMapLoading(false);
  };

  const onClick = (e) => {
    console.log(e);
  };

  return (
    <Root className={classes.root}
	sx={{
		flex: 2,
	    height: "100%",
	    [theme.breakpoints.down("sm")]: {
	      // flex: "auto",
	      marginTop: "2em",
	    },
	}}>
	      <MapContainer
	        id="map"
	        center={position}
	        zoom={3}
	        className={classes.map}
	        ref={map}
	        alt="map of study boundary"
	      >
	        <MapEvents />
	        <TileLayer
	          // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
	          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
	          // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
	        />
	        {Object.keys(geom).length > 0 ? (
	          <GeoJSON
	            style={styles.geom}
	            data={geom}
	            onClick={onClick}
	            onLoad={onLoad}
	          />
	        ) : (
	          <div className={classes.loadingContainer}>
	            <CircularProgress />
	          </div>
	        )}
	        {analysisGeoms.length > 0 ? (
	          analysisGeoms.map((geom, idx) => {
	            return (
	              <GeoJSON
	                key={idx}
	                style={styles.analysisGeom}
	                data={geom.geom}
	                onClick={onClick}
	              />
	            );
	          })
	        ) : (
	          <Fragment />
	        )}
	      </MapContainer>
    </Root>
  );
};

const mapStateToProps = (state) => ({
  geom: state.details.geom,
  analysisGeoms: state.details.analysis_geoms,
});

export default connect(mapStateToProps, {})(Map);
